import { render, staticRenderFns } from "./LinkWrapper.vue?vue&type=template&id=150d6ce4&"
import script from "./LinkWrapper.vue?vue&type=script&lang=js&"
export * from "./LinkWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports